import React, { Component } from 'react'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { connect } from 'react-redux'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { isSupportedForDomain } from '../../jsCore/application/pageDataObject'
import { SocialButtonsComponent } from './socialButtons.container'
import { shouldShowHeaderShareButtons } from '../../jsCore/store/shareButtons/shareButtons.selectors'

const COMPONENT_NAME = 'SocialButtonsHeaderWrapperComponent'
const SOCIAL_BUTTONS_FEATURE_ID = 'SocialButtons'

export class SocialButtonsHeaderWrapperComponent extends Component {
  render() {
    if (this.props.shouldShowButtons) {
      return <SocialButtonsComponent options={{ dataset: { position: 'header' } }} />
    }
    return null
  }
}

const mapStateToProps = state => ({ shouldShowButtons: shouldShowHeaderShareButtons(state) })

const socialButtons = {
  name: COMPONENT_NAME,
  component: connect(mapStateToProps, null)(SocialButtonsHeaderWrapperComponent),
}

function mountSocialButtonsHeaderWrapper() {
  return reduxMount({
    [MOUNT_POINTS.SHARE_HEADER_WRAPPER_COMPONENT]: socialButtons,
  })
}

export function initSocialButtonsHeaderWrapper() {
  const shouldMountSocialButtons = isSupportedForDomain(SOCIAL_BUTTONS_FEATURE_ID)
  if (shouldMountSocialButtons) {
    mountSocialButtonsHeaderWrapper()
  }
  return shouldMountSocialButtons
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/social_buttons/socialButtonsHeaderWrapper.container.js